import React, { useState } from 'react';
import { Title, Button } from '@fnacdarty/back-office-ui';
import PropTypes from 'prop-types';
import fileIcon from '../../../../assets/images/logos/fileIcon.png';
import ActivityFileItem from '../ActivityFileItem';
import Modal from '../../../../layouts/Modal';
import ActivityFileUpload from '../ActivityFileUpload';

import {
	StyledContainerActivityFile,
	StyledRowPrimaryFile,
	StyledRowFile,
} from './index.styled';

const ActivityFile = ({ activity }) => {
	const [data, setData] = useState({
		isPreview: false,
		isPreviewUpload: false,
		showDetails: false,
		showDeletion: false,
		showSend: false,
		downloadableDocument: false,
		content: null,
		file: null,
		closedPreview: false,
		mimeType: '',
		extension: '',
		libelleActivity: '',
		dossierActivity: '',
		document: '',
	});

	const [openModal, setOpenModal] = useState(false);
	const constantes = [
		{
			constantName: 'retourPose',
			libelle: 'la pose',
			dossier: 'fin de chantier',
		},
		{
			constantName: 'retourPoseDressing',
			libelle: 'la pose',
			dossier: 'fin de chantier',
		},
		{ constantName: 'retourMetre', libelle: 'le métré', dossier: 'métré' },
		{
			constantName: 'retourMetreDressing',
			libelle: 'le métré',
			dossier: 'métré',
		},
		{
			constantName: 'retourTavSav',
			libelle: 'le TAV/SAV',
			dossier: 'TAV/SAV',
		},
		{
			constantName: 'retourPdts',
			libelle: 'la pose décalée',
			dossier: 'pose décalée',
		},
		{
			constantName: 'retourLivrais',
			libelle: 'la livraison',
			dossier: 'livraison',
		},
	];

	const handleLinkClick = () => {
		if (activity.link) {
			// Cherchez le constantName dans le tableau multidimensionnel
			const constante = constantes.find(
				(item) => item.constantName === activity.link.constantName,
			);

			if (constante) {
				setData({
					libelleActivity: constante.libelle,
					dossierActivity: constante.dossier,
				});
			} else {
				// Si constantName n'est pas reconnu
				setData({
					libelleActivity: 'le métré',
					dossierActivity: 'métré',
				});
			}
		}
		setOpenModal(true);
	};

	const handleAddDocClick = async (response) => {
		if (response) {
			// console.log('valider');
		}
		setOpenModal(false);
	};
	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;
	let widtModal = '90%';
	if (isVersionPC()) {
		widtModal = '50%';
	}

	return (
		<>
			<StyledContainerActivityFile>
				{activity.documents.map((file, index) => (
					<ActivityFileItem
						key={index}
						file={file}
						data={data}
						setData={setData}
					/>
				))}

				{activity.link && (
					<hr style={{ width: '100%', marginTop: '100px' }} />
				)}

				{activity.link && (
					<StyledRowFile>
						<Button
							onClick={() => {
								handleLinkClick();
							}}
							style={{
								width: '25%',
							}}
						>
							{activity.link.libelle}
						</Button>
					</StyledRowFile>
				)}
			</StyledContainerActivityFile>
			{openModal && (
				<Modal
					onClickCallback={handleAddDocClick}
					title="Téléchargement des documents"
					cancelAction={''}
					confirmAction={''}
					style={{
						position: 'fixed',
						width: widtModal,
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: '100%',
							alignItems: 'center',
						}}
					>
						<ActivityFileUpload
							activity={activity}
							setOpenModal={setOpenModal}
							data={data}
						></ActivityFileUpload>
					</div>
				</Modal>
			)}
		</>
	);
};

ActivityFile.propTypes = {
	activity: PropTypes.object.isRequired,
};

export default ActivityFile;
